
const headers = [
  {
    label: 'วัตถุประสงค์เรื่อง/ รหัสเรื่อง',
    field: 'caseCode',
  },
  {
    label: 'ประเภท เรื่อง/ หัวข้อร้องทุกข์',
    field: 'complaintSubject',
  },
  {
    label: 'วันที่ส่งเรื่อง / สถานะ GCC / สถานะระบบร้องทุกข์',
    field: 'action',
  },
]

export default headers